import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_KEYWORD_KW_LISTS_PAGE: IInventoryPage = {
	'route': '/research/keyword/kw-lists',
	'title': 'KW Lists',
	'uiReference': [
		'Open list actions',
		'List Workspace',
		'keywords',
		'Save',
		'Save list',
		'Export lists',
		'KW Lists',
		'Info',
		'Categories',
		'Keyword List',
		'Create Your Keyword List!',
		'Saved Lists',
		'New List',
		'Saved keyword lists',
		'Import',
		'Export',
		'Filter',
		'&middot;',
		'From',
		'Name',
		'Add context or notes for this keyword list',
		'Enter keywords, separated by commas',
		'Details',
		'Notes',
		'Language',
		'Group related keywords and compare their search-volume history.',
		'Keywords',
		'Update Search Volume',
		'Add keywords',
		'Add to the selected category, then update Amazon and Google search volume above.',
		'/ keywords',
		'Amazon Search Volume History',
		'Google Search Volume History',
		'Empty Keywords List',
		'Show previous categories',
		'Keyword categories',
		'Add new category',
		'Show more categories',
		'Add Category',
		'more keywords available,',
		'show all available keywords',
		'viewing of all available keywords not included in Free Version',
		'Loading...',
		'Not enough data.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/kw-lists-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/kw-lists.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/kw-lists.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/kw-lists.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/kw-lists-menu/kw-lists-menu.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/kw-lists-menu/kw-lists-menu.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/kw-list-edit/kw-list-edit.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/kw-list-edit/kw-list-edit.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/kw-list-edit/kw-list-edit.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/category-select/category-select.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/kw-lists/sub-components/category-select/category-select.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/amazon-sv-chart/amazon-sv-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/amazon-sv-chart/amazon-sv-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/google-sv-chart/google-sv-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/google-sv-chart/google-sv-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table-row/kw-table-row.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/tables-and-helpers/kw-container/kw-table/kw-table-row/kw-table-row.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/empty-sv/empty-sv.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/statistics-and-charts/search-volume-chart/sub-components/empty-sv/empty-sv.component.html'
	],
	'aliases': [
		'Keyword Lists'
	]
};
